import { MapPin } from "lucide-react";
import { AREAS } from "../data/content";
import { Reveal, SectionHeading } from "./Reveal";

const SKYLINE =
  "https://images.pexels.com/photos/18039893/pexels-photo-18039893.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function Areas() {
  return (
    <section id="areas" className="py-20 md:py-28" data-testid="areas-section">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 sm:px-8 lg:grid-cols-2">
        <div>
          <SectionHeading
            overline="Local & remote"
            title="IT support in Birmingham & the West Midlands"
            copy="Based in Birmingham and serving the wider West Midlands — from Solihull and Sutton Coldfield to Wolverhampton, Walsall, Dudley and Coventry. On-site visits across the region, with remote support available UK-wide for most services."
          />
          <Reveal delay={0.15}>
            <div className="mt-8 flex flex-wrap gap-2" data-testid="areas-list">
              {AREAS.map((a) => (
                <span
                  key={a}
                  className={`inline-flex items-center gap-1.5 rounded-full border px-3.5 py-2 text-xs font-medium ${
                    a.startsWith("Remote")
                      ? "border-cyan-500/40 bg-cyan-500/10 text-cyan-300"
                      : "border-white/10 bg-white/[0.03] text-slate-300"
                  }`}
                >
                  <MapPin size={11} className={a.startsWith("Remote") ? "text-cyan-400" : "text-slate-500"} />
                  {a}
                </span>
              ))}
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <div className="relative" data-testid="areas-visual">
            <div className="absolute -inset-4 rounded-[2rem] bg-[radial-gradient(closest-side,rgba(0,102,255,0.16),transparent)] blur-xl" />
            <div
              className="relative overflow-hidden rounded-[1.6rem] border border-blue-500/25"
              style={{ clipPath: "polygon(0 4%, 100% 0, 100% 96%, 0 100%)" }}
            >
              <img src={SKYLINE} alt="Birmingham skyline" loading="lazy" className="h-[380px] w-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#070B19]/85 via-transparent to-transparent" />
              <div className="absolute bottom-5 left-5 right-5">
                <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-cyan-300">Home ground</p>
                <p className="font-display mt-1 text-lg font-bold text-slate-50">Birmingham, United Kingdom</p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
